import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const KlarnaWidget = ({price, variant}) => {
    const style = useMultiStyleConfig('Klarna', {variant})
    const priceToPass = Math.round(price?.currentPrice * 100)
    const {locale} = useMultiSite()
    const dataLocale = locale.id
    const paymentsConfiguration = useCustomPreference('paymentsConfiguration')

    useEffect(() => {
        window?.Klarna?.OnsiteMessaging?.refresh()
    }, [price])

    if (paymentsConfiguration && paymentsConfiguration?.klarna?.widgetEnabled !== 'true') return

    return (
        <Box __css={style.klarnaPlacement} justifySelf="flex-end">
            {priceToPass ? (
                <Box
                    id={'klarna-placement'}
                    as={'klarna-placement'}
                    data-key="credit-promotion-auto-size"
                    data-locale={dataLocale}
                    data-purchase-amount={priceToPass}
                    data-testid="klarna-placement"
                />
            ) : (
                <></>
            )}
        </Box>
    )
}

KlarnaWidget.propTypes = {
    price: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
    variant: PropTypes.string,
}

export default KlarnaWidget
